import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import GeneradorQR from '../components/GeneradorQR.vue'
import EtiquetasEscolares from '../components/EtiquetasEscolares.vue'
import PlantillasImprimibles from '../components/PlantillasImprimibles.vue'
import AfiliadosML from '../components/AfiliadosML.vue'
import NegociosAliados from '../components/NegociosAliados.vue'
import NotFound from '../components/NotFound.vue'

const routes = [
  { path: '/',           component: Home },
  { path: '/qr',         component: GeneradorQR },
  { path: '/etiquetas',  component: EtiquetasEscolares },
  { path: '/plantillas', component: PlantillasImprimibles },
  { path: '/pago',       component: Home },
  { path: '/ofertas-recomendadas',  component: AfiliadosML },
  // Sin enlaces en el sitio: solo accesible por URL directa (#/aliados)
  { path: '/aliados',    component: NegociosAliados },
  // Debe ir al final: cualquier ruta no definida muestra la página 404
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise(resolve => {
        setTimeout(() => resolve({ el: to.hash, behavior: 'smooth' }), 120)
      })
    }
    return { top: 0 }
  }
})

const GA_ID = 'G-80Z9N91M5J'

// Con createWebHashHistory la ruta viaja en el fragmento (#/qr) y GA4 lo descarta
// al derivar la ruta de página: todo se reportaría como "/". Por eso se sintetiza
// page_location sin el '#'. Nota: page_path es de Universal Analytics, GA4 lo ignora.
router.afterEach((to) => {
  if (process.env.NODE_ENV !== 'production') return
  if (typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    send_to: GA_ID,
    page_location: window.location.origin + to.fullPath,
    page_title: document.title,
  })
})

export default router
